import { render, staticRenderFns } from "./desModal.vue?vue&type=template&id=4ad3709c"
import script from "./desModal.vue?vue&type=script&lang=js"
export * from "./desModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports